module.exports = __webpack_public_path__ + "static/media/ph_g06.ef0074ac.jpg";